// import { Selection } from '@leverege/ui-redux'
import { Selection } from '@leverege/ui-redux';
import GeoPointAdapter from "./GeoPointAdapter.js";
import Util from "./Util.js";
import Model from "../../shared/renderers/HistoryModel.js";
import { HistoryAccumulators } from "../../shared/renderers/accumulator/index.js";
const {
  getLineColor,
  getLineWidth,
  getLinePattern,
  getLineOpacity,
  getLineCap,
  getLineJoin,
  getLineStyle,
  getSelectedLineColor,
  getSelectedLineWidth,
  getSelectedLinePattern,
  getSelectedLineOpacity,
  getSelectedLineCap,
  getSelectedLineJoin,
  getSelectedLineStyle,
  getRolloverLineColor,
  getRolloverLineWidth,
  getRolloverLinePattern,
  getRolloverLineOpacity,
  getRolloverLineCap,
  getRolloverLineJoin,
  getRolloverLineStyle
} = Model;
class HistoryAdapter extends GeoPointAdapter {
  constructor(opts) {
    super(opts);
    this.Model = Model;
    this.attributeName = opts?.attributeName;
  }
  getShapeData(item, id, options) {
    const {
      model
    } = options;
    const lineCoordinates = [];
    const pts = HistoryAccumulators.getPoints(Model.getAccumulator(model), item.items, options);
    const points = pts.reduce(this.getShapeDataReducer(options, lineCoordinates), []);
    const lines = this.getLinesFromLineCoordinates(lineCoordinates);
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].geometry.coordinates.length) {
        const app = {
          visible: true,
          name: null
        };
        let {
          model
        } = options;
        model = model || {};
        if (lines[i].selected) {
          app.lineColor = Util.getColor(getSelectedLineColor(model), item);
          app.lineOpacity = Util.getNumber(getSelectedLineOpacity(model), item);
          app.linePattern = Util.getPattern(getSelectedLinePattern(model), item);
          app.lineWidth = Util.getNumber(getSelectedLineWidth(model), item);
          app.lineCap = getSelectedLineCap(model) || 'butt';
          app.lineJoin = getSelectedLineJoin(model) || 'mitre';
          app.lineStyle = getSelectedLineStyle(model) || 'default';
          app.textColor = app.lineColor;
          app.textSize = app.lineWidth * 10;
          app.layerGroup = 'selected';
          app.showOutline = false;
          app.showLine = true;
        } else if (lines[i].rollover) {
          app.lineColor = Util.getColor(getRolloverLineColor(model), item);
          app.lineOpacity = Util.getNumber(getRolloverLineOpacity(model), item);
          app.linePattern = Util.getPattern(getRolloverLinePattern(model), item);
          app.lineWidth = Util.getNumber(getRolloverLineWidth(model), item);
          app.lineCap = getRolloverLineCap(model) || 'butt';
          app.lineJoin = getRolloverLineJoin(model) || 'mitre';
          app.lineStyle = getRolloverLineStyle(model) || 'default';
          app.textColor = app.lineColor;
          app.textSize = app.lineWidth * 10;
          app.layerGroup = 'rollover';
          app.showOutline = false;
          app.showLine = true;
        } else {
          app.lineColor = Util.getColor(getLineColor(model), item);
          app.lineOpacity = Util.getNumber(getLineOpacity(model), item);
          app.linePattern = Util.getPattern(getLinePattern(model), item);
          app.lineWidth = Util.getNumber(getLineWidth(model), item);
          app.lineCap = getLineCap(model) || 'butt';
          app.lineJoin = getLineJoin(model) || 'mitre';
          app.lineStyle = getLineStyle(model) || 'default';
          app.showOutline = false;
          app.showLine = true;
        }
        points.push({
          geoJson: lines[i],
          appearance: app
        });
      }
    }
    return points;
  }
  getShapeDataReducer(options, lineCoordinates) {
    return (prev, curr) => {
      let accum;
      let raw;

      // const { selected } = options

      if (curr.accum) {
        accum = curr.accum;
        raw = curr.raw; // eslint-disable-line
      } else {
        accum = curr;
      }
      let parentShapeData = super.getShapeData(accum, accum.id, options);
      parentShapeData = Array.isArray(parentShapeData) ? parentShapeData[0] : parentShapeData;
      const coordinates = parentShapeData?.geoJson?.geometry?.coordinates;
      const selected = Selection.isSelected(options.selected, accum.id);
      const rollover = Selection.isSelected(options.rollover, accum.id);
      if (coordinates) {
        lineCoordinates.push({
          coordinates,
          selected,
          rollover
        });
      }
      if (parentShapeData) {
        prev.push({
          ...parentShapeData,
          appearance: {
            ...parentShapeData.appearance,
            dataId: accum.id
          }
        });

        // Uncomment to show rollup points on map when selected

        // if ( Array.isArray( raw ) && raw.length > 0 ) {
        //   raw.forEach( ( r ) => {
        //     const rShapeData = super.getShapeData( r, accum.id, options )
        //     prev.push( {
        //       ...rShapeData,
        //       appearance : {
        //         ...rShapeData.appearance,
        //         visible : Selection.isSelected( selected, accum.id )
        //       }
        //     } )
        //   } )
        // }
      }
      return prev;
    };
  }
  getLinePaint(style) {
    const p = {
      'line-color': ['case', ['has', 'lineColor'], ['get', 'lineColor'], 'rgb( 0,0,0 )'],
      'line-width': ['case', ['has', 'lineWidth'], ['get', 'lineWidth'], 1],
      'line-offset': ['case', ['has', 'lineOffset'], ['get', 'lineOffset'], 0],
      'line-opacity': ['case', ['has', 'lineOpacity'], ['get', 'lineOpacity'], 1]
    };
    switch (style) {
      case 'pattern':
        p['line-pattern'] = ['get', 'linePattern'];
        break;
      case 'long-dash':
        p['line-dasharray'] = [8, 3];
        break;
      case 'short-dash':
        p['line-dasharray'] = [3, 3];
        break;
      case 'dot':
        p['line-dasharray'] = [1, 2];
        break;
      case 'default':
      case 'custom':
        break;
      default:
        {
          const dashString = style.substring(5);
          const dashArray = dashString.split('-').reduce((prev, curr) => {
            prev.push(parseInt(curr));
            return prev;
          }, []);
          p['line-dasharray'] = dashArray;
        }
    }
    return p;
  }
  getLineLayout(style, layerGroup, options) {
    const {
      model
    } = options;
    const lineCap = Model.getLineCap(model) || 'butt';
    const lineJoin = Model.getLineJoin(model) || 'miter';
    return {
      'line-cap': lineCap,
      'line-join': lineJoin
    };
  }
  getLineSymbolLayout(style, layerGroup, options) {
    return {
      'text-field': '◄',
      'text-size': ['get', 'textSize'],
      'symbol-placement': 'line',
      'symbol-spacing': 32,
      'text-rotation-alignment': 'map',
      'text-keep-upright': false
    };
  }
  getLineSymbolPaint(style, layerGroup, options) {
    return {
      'text-color': ['get', 'textColor']
    };
  }
  getLinesFromLineCoordinates(lineCoordinates) {
    const lines = [{
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'LineString',
        coordinates: []
      },
      selected: false,
      rollover: false
    }];
    for (let i = 0; i < lineCoordinates.length; i++) {
      if (lineCoordinates[i].rollover || lineCoordinates[i].selected) {
        lines.push({
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: []
          },
          selected: lineCoordinates[i].selected,
          rollover: lineCoordinates[i].rollover
        });

        // Add previous coordinate if available.
        if (i > 0) {
          lines[lines.length - 1].geometry.coordinates.push(lineCoordinates[i - 1].coordinates);
        }

        // Add current coordinate.
        lines[lines.length - 1].geometry.coordinates.push(lineCoordinates[i].coordinates);

        // Add next coordinate if available.
        if (i < lineCoordinates.length - 1) {
          lines[lines.length - 1].geometry.coordinates.push(lineCoordinates[i + 1].coordinates);
        }
        lines.push({
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates: []
          },
          selected: false,
          rollover: false
        });
      } else {
        lines[lines.length - 1].geometry.coordinates.push(lineCoordinates[i].coordinates);
      }
    }
    return lines;
  }
}
export default HistoryAdapter;